import type { OrgPresentationMode } from "../../../../../../../_shared/_logic/presentation-mode"

export const buildCodeGateDescription = ({
  presentationMode,
  hasCodeInUrl,
}: {
  presentationMode: OrgPresentationMode
  hasCodeInUrl: boolean
}): string => {
  if (hasCodeInUrl) {
    return "Der Code aus Ihrem Link ist vorausgefüllt. Falls die Terminseite nicht automatisch lädt, können Sie ihn hier prüfen und erneut öffnen."
  }

  if (presentationMode === "appointment_portal_only") {
    return "Geben Sie den Code aus Ihrer E-Mail, mobilen Nachricht oder Ihrem Brief ein. Ohne Code kann die Terminseite Ihren Termin nicht sicher zuordnen; bitte wenden Sie sich an den Betrieb."
  }

  return "Wenn Sie einen Termincode erhalten haben, geben Sie ihn hier ein. Ohne Code können Sie auf der Seite KehrAssist einen Termin vereinbaren, verschieben oder Ihr Anliegen klären."
}
